import { Button } from "../Button/Button";
import AddressAutocomplete from "../FormInputs/AutoComplete";
import TextInput from "../FormInputs/TextInput2";
import { FormikProvider, useFormik } from "formik";

export default function PersonalInformation({
  form,
  handleSubmit,
  product,
  setShowUploadPage,
}: any) {
  const productType = process.env.REACT_APP_PRODUCT_TYPE;
  const isAjoHomeProduct =
    process.env.REACT_APP_PRODUCT_TYPE?.trim().toLowerCase() === "ajohome";

  return (
    <div className="max-w-[513px] overflow-y-auto rounded-[10px] w-full bg-white mt-9 border border-[#19124A] py-6 px-5 ">
      <h3 className="md:text-3xl text-xl font-medium">
        Complete Personal Information
      </h3>

      <FormikProvider value={form}>
        <form className="mt-6 overflow-y-auto" onSubmit={form.handleSubmit}>
          <div className="rounded-[10px] border p-4">
            <h3 className="text-base md:text-lg font-semibold">
              Personal Information
            </h3>

            <div className="mt-3">
              <div className="grid grid-cols-2 gap-2">
                <TextInput
                  name="firstName"
                  label="First Name"
                  placeholder="Enter your first name"
                  required={true}
                />

                <TextInput
                  name="lastName"
                  label="Last Name"
                  placeholder="Enter your last name"
                  required={true}
                />
              </div>

              <TextInput
                type="date"
                name="dateOfBirth"
                label="Date of Birth"
                wrapperClass="mt-3"
                placeholder="Enter your date of birth"
                required={true}
              />

              <TextInput
                name="email_address"
                label="Email"
                wrapperClass="mt-3"
                placeholder="Enter your email"
                required={true}
              />

              <TextInput
                name="phoneNumber"
                label="Phone Number"
                wrapperClass="mt-3"
                placeholder="Enter your phone number"
                required={true}
              />

              <div className="mt-3">
                <label className="font-normal text-sm font-satoshiRegular capitalize mb-1.5">
                  <div className="flex items-center">
                    {" "}
                    <span>Home Address </span>{" "}
                    <span className="text-red-500 text-[15px] text-center font-bold ml-1">
                      *
                    </span>
                  </div>
                </label>

                <AddressAutocomplete form={form} />

                {form.touched.homeAddress && form.errors.homeAddress ? (
                  <small className="text-red-600 mt-1 text-xs md:text-sm">
                    {String(
                      form.errors.homeAddress ||
                        "Please select an address from the dropdown suggestions",
                    )}
                  </small>
                ) : null}
              </div>

              <div className="grid grid-cols-3 gap-2">
                <TextInput
                  name="city"
                  label="City"
                  wrapperClass="mt-3"
                  placeholder="city"
                  required={true}
                />

                <TextInput
                  name="state"
                  label="Province"
                  wrapperClass="mt-3"
                  placeholder="Province"
                  required={true}
                />

                <TextInput
                  name="zipCode"
                  label="Zip Code"
                  wrapperClass="mt-3"
                  placeholder="Zip Code"
                  required={true}
                />
              </div>

              <div className="mt-3">
                <label className="font-normal text-sm font-satoshiRegular capitalize mb-1.5">
                  <div className="flex items-center">
                    {" "}
                    <span>
                      What is the primary source of your investment funds?
                    </span>{" "}
                    <span className="text-red-500 text-[15px] text-center font-bold ml-1">
                      *
                    </span>
                  </div>
                </label>

                <select
                  {...form.getFieldProps("sourceOfFunds")}
                  name="sourceOfFunds"
                  className="w-full p-2 border h-[44px] bg-white rounded-lg mt-2"
                  required={true}
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="Business Profits">Business Profits</option>
                  <option value="Inheritance/Gift">Inheritance/Gift</option>
                  <option value="Investment Portfolio Liquidation">
                    Investment Portfolio Liquidation
                  </option>
                  <option value="Personal Savings">Personal Savings</option>
                </select>

                {form.touched.sourceOfFunds && form.errors.sourceOfFunds ? (
                  <small className="text-red-600 mt-1 text-xs md:text-sm">
                    {String(form.errors.sourceOfFunds)}
                  </small>
                ) : null}
              </div>

              <div className="mt-3">
                <label className="font-normal text-sm font-satoshiRegular capitalize mb-1.5">
                  <div className="flex items-center">
                    {" "}
                    <span>
                      Are you acting on behalf of, or at the instruction of, a
                      third party?
                    </span>{" "}
                    <span className="text-red-500 text-[15px] text-center font-bold ml-1">
                      *
                    </span>
                  </div>
                </label>

                <select
                  {...form.getFieldProps("actingOnBehalf")}
                  name="actingOnBehalf"
                  className="w-full p-2 border h-[44px] bg-white rounded-lg mt-2"
                  required={true}
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                {form.touched.actingOnBehalf && form.errors.actingOnBehalf ? (
                  <small className="text-red-600 mt-1 text-xs md:text-sm">
                    {String(form.errors.actingOnBehalf)}
                  </small>
                ) : null}
              </div>
            </div>
          </div>

          <div className="rounded-[10px] mt-4 border p-4">
            <h3 className="text-base md:text-lg font-semibold">
              Employer Information
            </h3>

            <div className="mt-3">
              <TextInput
                name="jobTitle"
                label="Job Title"
                placeholder="Enter your Job Title"
                required={true}
              />

              <TextInput
                name="employerName"
                label="Employer Name"
                wrapperClass="mt-3"
                placeholder="Enter your Employer Name"
                required={true}
              />

              <TextInput
                name="employerPhoneNumber"
                label="Employer Phone Number"
                wrapperClass="mt-3"
                placeholder="Enter your phone number"
                required={true}
              />
            </div>
          </div>

          {isAjoHomeProduct && (
            <div className="rounded-[10px] mt-4 border p-4">
              <h3 className="text-base md:text-lg font-semibold">
                Next of Kin
              </h3>
              <p className="text-sm text-[#5A5C5E]">
                Who should we contact, and where should any payout go, if
                we're ever unable to reach you directly?
              </p>

              <div className="mt-3">
                <TextInput
                  name="nextOfKinName"
                  label="Full Name"
                  placeholder="Enter their full name"
                  required={true}
                />

                <TextInput
                  name="nextOfKinRelationship"
                  label="Relationship To You"
                  wrapperClass="mt-3"
                  placeholder="e.g. Spouse, Sibling, Parent"
                  required={true}
                />

                <TextInput
                  name="nextOfKinPhone"
                  label="Phone Number"
                  wrapperClass="mt-3"
                  placeholder="Enter their phone number"
                  required={true}
                />

                <TextInput
                  name="nextOfKinEmail"
                  type="email"
                  label="Email Address"
                  wrapperClass="mt-3"
                  placeholder="Enter their email address"
                  required={true}
                />

                <TextInput
                  name="nextOfKinAddress"
                  label="Mailing Address"
                  wrapperClass="mt-3"
                  placeholder="Enter their mailing address"
                  required={true}
                />
              </div>
            </div>
          )}

          <div className="rounded-[10px] mt-4 border p-4">
            <h3 className="text-base md:text-lg font-semibold">Others</h3>
            <div className="mt-3">
              <div>
                <label className="font-normal text-sm font-satoshiRegular capitalize mb-1.5">
                  <div className="flex items-center">
                    {" "}
                    <span>How did you hear of us?</span>{" "}
                    <span className="text-red-500 text-[15px] text-center font-bold ml-1">
                      *
                    </span>
                  </div>
                </label>

                <select
                  {...form.getFieldProps("others")}
                  name="others"
                  className="w-full p-2 border h-[44px] bg-white rounded-lg mt-2"
                  required={true}
                >
                  <option value="" disabled selected>
                    Select an option
                  </option>
                  <option value="WhatsApp group">WhatsApp group</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Referrals">Referrals</option>
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="Realtor">Realtor</option>
                  <option value="other">Other</option>
                </select>

                {form.touched.others && form.errors.others ? (
                  <small className="text-red-600 mt-1 text-xs md:text-sm">
                    {String(form.errors.others)}
                  </small>
                ) : null}

                {(form.getFieldProps("others").value === "other" ||
                  form.getFieldProps("others").value === "WhatsApp group" ||
                  form.getFieldProps("others").value === "Referrals" ||
                  form.getFieldProps("others").value === "Realtor") && (
                  <TextInput
                    name="other"
                    wrapperClass="mt-3"
                    placeholder={
                      form.getFieldProps("others").value === "other"
                        ? "Please specify"
                        : form.getFieldProps("others").value ===
                            "WhatsApp group"
                          ? "Enter WhatsApp group name"
                          : form.getFieldProps("Realtor").value === "Realtor"
                            ? "Enter realtor details"
                            : "Enter referral details"
                    }
                  />
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-between mt-6">
            <button
              onClick={() => product.closeKyc(false)}
              type="button"
              className="px-5 py-2 border border-[#D42620] text-[#D42620] rounded-md"
            >
              Cancel
            </button>

            <Button
              // onClick={() => {
              //   form.validateForm();
              //   console.log("I was clicked!", form);
              // }}
              label="Proceed"
              isLoading={handleSubmit.isLoading}
              disabled={handleSubmit.isLoading || !form.isValid}
              className="px-5"
            />
          </div>
        </form>
      </FormikProvider>

      <div></div>
    </div>
  );
}
